import './HvacResultSavingsView.scss';
import { EvaluationResults, HvacArea, HvacResults } from '@belimo-retrofit-portal/logic';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tab } from 'src/modules/common/components/Tab';
import { TabList } from 'src/modules/common/components/TabList';
import { TabPanel } from 'src/modules/common/components/TabPanel';
import { TabPanels } from 'src/modules/common/components/TabPanels';
import { Tabs } from 'src/modules/common/components/Tabs';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';
import { HvacNotification } from 'src/modules/hvac/types/HvacNotification';
import { HvacResultSavingsExplanation } from 'src/modules/hvac/views/HvacResultSavingsExplanation';
import { HvacResultSavingsOverall } from 'src/modules/hvac/views/HvacResultSavingsOverall';
import { HvacResultSavingsSystem } from 'src/modules/hvac/views/HvacResultSavingsSystem';
import { SaveProjectForm } from 'src/modules/save-project/SaveProjectForm';

type Props = {
  readonly form: HvacFormData;
  readonly results: HvacResults;
  readonly evaluationResults: EvaluationResults;
  readonly insufficientInputs: ReadonlyArray<HvacNotification>;
  readonly incompleteResults: boolean;
};

export const HvacResultSavingsView = ({
  form,
  results,
  evaluationResults,
  insufficientInputs,
  incompleteResults,
}: Props): React.ReactElement => {
  const intl = useIntl();

  const [activeTab, setActiveTab] = useState(0);

  const heatingEnabled = true; // form.assessment.areas[HvacArea.HEATING].enabled;
  const coolingEnabled = true; // form.assessment.areas[HvacArea.COOLING].enabled;
  const ventilationEnabled = true; // form.assessment.areas[HvacArea.VENTILATION].enabled;

  return (
    <>
      <div className="bp-hvac-result-savings-view">
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
          <TabList>
            <Tab theme="white" size="lg" bordered={true}>
              <FormattedMessage id="hvac/tab/overall"/>
            </Tab>

            <Tab
              theme="white"
              size="lg"
              disabled={!heatingEnabled}
              bordered={true}
              tooltipValue={heatingEnabled ? null : intl.formatMessage({ id: 'tab/heating/disabled' })}
            >
              <FormattedMessage id="hvac/tab/heating"/>
            </Tab>

            <Tab
              theme="white"
              size="lg"
              disabled={!coolingEnabled}
              bordered={true}
              tooltipValue={coolingEnabled ? null : intl.formatMessage({ id: 'tab/cooling/disabled' })}
            >
              <FormattedMessage id="hvac/tab/cooling"/>
            </Tab>

            <Tab
              theme="white"
              size="lg"
              disabled={!ventilationEnabled}
              tooltipValue={ventilationEnabled ? null : intl.formatMessage({ id: 'tab/ventilation/disabled' })}
            >
              <FormattedMessage id="hvac/tab/ventilation"/>
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <div className="bp-hvac-result-savings-view__panel">
                <HvacResultSavingsOverall
                  form={form}
                  results={results}
                />
              </div>
            </TabPanel>

            <TabPanel>
              <HvacResultSavingsSystem
                currency={form.currency}
                results={results.perArea[HvacArea.HEATING]}
              />
            </TabPanel>

            <TabPanel>
              <HvacResultSavingsSystem
                currency={form.currency}
                results={results.perArea[HvacArea.COOLING]}
              />
            </TabPanel>

            <TabPanel>
              <HvacResultSavingsSystem
                currency={form.currency}
                results={results.perArea[HvacArea.VENTILATION]}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
      <HvacResultSavingsExplanation
        results={results.overall.savings.overall.absolute}
        insufficientInputs={insufficientInputs}
        incompleteResults={incompleteResults}
      >
        <SaveProjectForm/>
      </HvacResultSavingsExplanation>

    </>
  );
};
